module.exports = __webpack_public_path__ + "static/media/dialogues.b67de486.png";